//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * The insertion point type.
 */
export interface InsertionPoint {
    /**
     * The left context.
     */
    left: string;

    /**
     * The right context.
     */
    right: string;
}
